import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import HeaderBar from '../../Layout/HeaderBar';
import FooterBar from '../../Layout/FooterBar';
import InventoryNav, { inventoryCategories } from './InventoryNav';

export default function InventoryView() {
  const { t } = useTranslation();
  return (
    <Layout>
      <HeaderBar />
      <Layout.Content className="min-w-0 px-4 py-6 md:px-6">
        <div className="mx-auto max-w-7xl space-y-6">
          <InventoryNav />
          <div>
            <h1 className="m-0 text-2xl font-semibold tracking-tight">{t('header.inventory')}</h1>
            <p className="mb-0 mt-2 text-sm text-muted-foreground">
              {t('Vælg udstyr for at se beholdning, status og tilknytning.')}
            </p>
          </div>
          <Link
            to="/inventory/sensors"
            className="block rounded-xl border bg-background p-5 text-foreground shadow-sm"
          >
            <h2 className="text-base font-semibold">Alle sensorer og lagerkoblinger</h2>
            <p className="mb-0 text-sm text-muted-foreground">
              Alle sensortyper, automatisk tilknytning og konflikter til kontrol.
            </p>
          </Link>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {inventoryCategories.map(({ type, label, icon: Icon, description }) => (
              <Link
                key={type}
                to={`/inventory/${type}`}
                className="group flex items-center gap-4 rounded-xl border bg-background p-5 text-foreground shadow-sm transition-colors hover:border-primary/40 hover:bg-muted/30 hover:!text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <span className="rounded-lg bg-muted p-3">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <div className="min-w-0 flex-1">
                  <h2 className="m-0 text-base font-semibold">
                    {t(label === 'machineActivity' ? 'Maskinaktivitet' : label === 'simcards' ? 'SIM-kort' : `sidenavInventory.${label}`)}
                  </h2>
                  <p className="mb-0 mt-1 text-sm text-muted-foreground">{t(description)}</p>
                </div>
                <ArrowRight
                  className="h-4 w-4 shrink-0 text-muted-foreground group-hover:text-foreground"
                  aria-hidden="true"
                />
              </Link>
            ))}
          </div>
        </div>
      </Layout.Content>
      <FooterBar />
    </Layout>
  );
}
